/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

// React Router
import { Link } from 'react-router-dom';
// Images
import faq from '../assets/images/illustrations/faq.png';
import logo from '../assets/logo.svg';

function Footer() {
    return (
        <footer className="bg-primaryDark mt-24">
            <div className="max-w-7xl mx-auto px-5 sm:px-5 lg:px-5 py-5">
                <div className="cto bg-primaryLight rounded-lg py-9 sm:py-9 md:py-9 lg:py-0 px-10" Style="margin-top: -85px;">
                    <div className="flex flex-wrap items-center">
                        <div className="flex items-center mb-8 sm:mb-8 md:mb-0 lg:mb-0">
                            <img src={faq} alt="Query Support" className="w-72 hidden sm:hidden md:hidden lg:block pt-2" Style="margin-top: -30px;" />
                            <div className="ml-0 sm:ml-0 md:ml-0 lg:ml-20">
                                <h1 className="text-gray-100 text-2xl font-semibold mb-1">Have a Query?</h1>
                                <p className="text-gray-300">Contact our support team, we are ready to help!</p>
                            </div>
                        </div>
                        <div className="ml-0 sm:ml-0 md:ml-auto lg:ml-auto">
                            <a href="https://client.cyperhost.com/submitticket.php" className="bg-gray-100 border border-gray-100 px-7 py-2.5 text-gray-900 font-semibold rounded-md text-sm">Contact Us</a>
                        </div>
                    </div>
                </div>
                <div className="content grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-5 gap-12 mt-24 pb-16 border-b border-gray-600">
                    <div className="col-span-1 sm:col-span-1 md:col-span-1 lg:col-span-1 xl:col-span-2">
                        <img src={logo} alt="Cyperhost" className="w-48 mb-6" />
                        <p className="text-gray-100">We strive to maintain a low overhead while adhering to an exceptionally high standard for quality.</p>
                    </div>
                    <div>
                        <h1 className="text-gray-100 font-semibold text-xl mb-5">Product Lines</h1>
                        <ul>
                            <li className="pb-2">
                                <Link to="/games" className="text-gray-300 hover:text-gray-100 hover:underline">Game Server Hosting</Link>
                            </li>
                            <li className="pb-2">
                                <Link to="/games/minecraft" className="text-gray-300 hover:text-gray-100 hover:underline">Minecraft Server Hosting</Link>
                            </li>
                            <li className="pb-2">
                                <Link to="/hosting/web-hosting" className="text-gray-300 hover:text-gray-100 hover:underline">Web Hosting</Link>
                            </li>
                            <li className="pb-2">
                                <Link to="/hosting/discord" className="text-gray-300 hover:text-gray-100 hover:underline">Discord Hosting</Link>
                            </li>
                            <li>
                                <Link to="/hosting/reseller" className="text-gray-300 hover:text-gray-100 hover:underline">Reseller Hosting</Link>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <h1 className="text-gray-100 font-semibold text-xl mb-5">Top Game Servers</h1>
                        <ul>
                            <li className="pb-2">
                                <Link to="/games/minecraft" className="text-gray-300 hover:text-gray-100 hover:underline">Minecraft</Link>
                            </li>
                            <li className="pb-2">
                                <Link to="/games/ark" className="text-gray-300 hover:text-gray-100 hover:underline">ARK: Survival Evolved</Link>
                            </li>
                            <li className="pb-2">
                                <Link to="/games/valheim" className="text-gray-300 hover:text-gray-100 hover:underline">Valheim</Link>
                            </li>
                            <li className="pb-2">
                                <Link to="/games/garrys-mod" className="text-gray-300 hover:text-gray-100 hover:underline">Garrys Mod</Link>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <h1 className="text-gray-100 font-semibold text-xl mb-5">Legal Resources</h1>
                        <ul>
                            <li className="pb-2">
                                <Link to="/legal/terms" className="text-gray-300 hover:text-gray-100 hover:underline">Terms of Service</Link>
                            </li>
                            <li className="pb-2">
                                <Link to="/legal/privacy" className="text-gray-300 hover:text-gray-100 hover:underline">Privacy Policy</Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="copyright mt-12">
                    <div className="flex items-center">
                        <div>
                            <h1 className="text-gray-100">&copy; Copyright 2022 <Link to="/" className="hover:text-white hover:underline">Cyperhost</Link>. All Rights Reserved.</h1>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer